// @ts-expect-error js-sha1 ships without type declarations and no @types package is installed
import * as sha1 from 'js-sha1';

import { PASSWORD_TOKEN_SHA1 } from '../../config/config';

/**
 * Hash the backend expects as the password of a LAB4U user.
 * The email is lowercased here so the hash never depends on how it was typed.
 */
export function hashPassword(email: string, password: string): string {
  return sha1(email.toLowerCase() + password + PASSWORD_TOKEN_SHA1);
}

/** Hash the backend expects as the `third_party_id` of an SSO user */
export function hashThirdPartyId(id: string): string {
  return sha1(id + PASSWORD_TOKEN_SHA1);
}
